const projects = [
    {
        name: 'Forage',
        type: 'Interactive experiment · Reinforcement learning',
        href: '/experiments/forage',
    },
    {
        name: 'Ease Attendance',
        type: '121K+ students · Web / APIs',
        href: '/ease-attendance',
    },
    {
        name: 'Rift',
        type: '15K+ users · iOS / SwiftUI',
        href: 'https://apps.apple.com/ug/app/rift-student/id1590799737',
    },
    {
        name: 'Bord',
        type: 'macOS · SwiftUI · Core Graphics',
        href: 'https://github.com/adityapatel-sudo/bord',
    },
    {
        name: 'MyCadences',
        type: 'Music · Spotify',
        href: '/mycadences',
    },
    {
        name: 'Distributed Systems Labs',
        type: 'Coursework · Java · Paxos / sharding / transactions',
        href: '/coursework/distributed-systems',
        featured: true,
    },
    {
        name: 'Unix Shell (CS 252)',
        type: 'Coursework · C++ · Lex/Yacc',
        href: '/coursework/unix-shell',
    },
    {
        name: 'Xinu Operating Systems (CS 354)',
        type: 'Coursework · C · Kernel systems',
        href: '/coursework/operating-systems',
    },
    {
        name: 'AI Search Agents (CS 471)',
        type: 'Coursework · Python · Search and game AI',
        href: '/coursework/ai-search-agents',
    },
];

export default projects;
